<template>
    <div class="feedback" :class="'feedback--view-' + view" data-html2canvas-ignore="true">
        <div class="feedback__wrap">
            <div v-show="step === 1" class="feedback__title">Ți-au fost de ajutor aceste informații?</div>
            <div v-show="step === 1" class="feedback__buttons">
                <a @click.prevent="like" href="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192">
                        <title>Da</title>
                        <g id="dfbb48cd-8135-422e-beb2-f81293bae682" data-name="Like_ic">
                            <g id="1f3335dd-fd79-4b79-9746-773d2421d43c" data-name="Dislike 2"><rect width="192" height="192" fill="none" /></g>
                            <path d="M43.21,172H145.58c11.53,0,21-8.94,15.87-21.45C173.2,137,167,126.75,167,126.75s11.11-12.06.32-23.8c2.79-7.85,4.4-14.79-5.84-21.73S126.9,81,118,82.13C106.12,78.33,141.58,21,103.84,20c-.16.41-4.4-1-3.2,13.88,0,15.53-29.32,50.12-38.91,63.58" fill="none" stroke="#333" stroke-linejoin="round" stroke-width="8" />
                            <path d="M68,172H40a20,20,0,0,1-20-20V112A20,20,0,0,1,40,92h8a20,20,0,0,1,20,20Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" />
                        </g>
                    </svg>
                </a>
                <a @click.prevent="dislike" href="">
                    <svg xmlns="http://www.w3.org/2000/svg" width="192" height="192" viewBox="0 0 192 192">
                        <title>Nu</title>
                        <g id="1a40c217-1008-418b-bbae-447ac73acf4a" data-name="Dislike 2">
                            <rect width="192" height="192" fill="none" />
                            <g id="438d4a9b-85b5-4719-96b5-cbf35ce3a57f" data-name="Like_ic">
                                <path d="M43.21,20H145.58c11.53,0,21,8.94,15.87,21.45C173.2,55,167,65.25,167,65.25s11.11,12.06.32,23.8c2.79,7.85,4.4,14.79-5.84,21.73s-34.54.18-43.42-.91c-11.9,3.8,23.55,61.14-14.19,62.13-.16-.41-4.4,1-3.2-13.88,0-15.53-29.31-50.11-38.9-63.57" fill="none" stroke="#333" stroke-linejoin="round" stroke-width="8" />
                                <path d="M68,20H40A20,20,0,0,0,20,40V80a20,20,0,0,0,20,20h8A20,20,0,0,0,68,80Z" fill="none" stroke="#333" stroke-linecap="round" stroke-linejoin="round" stroke-width="8" />
                            </g>
                        </g>
                    </svg>
                </a>
            </div>
            <div class="feedback__comment" v-show="step === 2">
                <div>Comentariul tău (opțional):</div>
                <textarea ref="comment" v-model="comment" class="feedback__textarea" rows="3"></textarea>
                <button @click="sendFeedback" type="button" class="button button--primary">Trimite</button>
            </div>
            <div v-show="step === 3" class="feedback__thanks">Mulțumim pentru răspunsul tău!</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Feedback',
    props: ['view'],
    data() {
        return {
            step: 1,
            isLike: null,
            sending: false,
            comment: '',
        };
    },
    methods: {
        like() {
            this.isLike = true;
            this.step = 2;
            this.focusComment();
        },

        dislike() {
            this.isLike = false;
            this.step = 2;
            this.focusComment();
        },

        focusComment() {
            this.$nextTick(() => {
                this.$refs['comment'].focus();
            });
        },

        sendFeedback() {
            var $this = this;
            var locatie = this.$route.path === '/' ? 'Homepage' : this.$route.path;
            var data = {
                formId: 322,
                EmailId: 1,
                Locatie: locatie,
                Comentariu: this.comment,
            };
            if (this.sending) return false;
            this.sending = true;
            if (this.isLike) {
                data['Da'] = 'Da';
            } else {
                data['Nu'] = 'Nu';
            }
            $.ajax({
                type: 'POST',
                url: 'https://www.vodafone.ro/system/webforms/submit/index.htm',
                data: data,
                success: function () {
                    $this.step = 3;
                },
            });
        },
    },
};
</script>
